<template>
  <el-dialog
    :title="`Split Line ${lineNumber}`"
    :model-value="!!lineNumber"
    width="30%"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false">
    <el-row type="flex" align="middle" style="margin-bottom: 12px;">
      <el-col :span="16">
        <el-row type="flex" align="middle" justify="start">
          Enter the number of ways to split line {{ lineNumber }}
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row type="flex" align="middle" justify="end" style="color: palevioletred;">
          {{ errMsg }}
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-input-number size="small" :min="2" v-model="waysToSplit" id="splitInput" />
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" align="middle" style="padding: 20px 0 0 0;">
      <el-button @click="hideModal">
        Cancel
      </el-button>
      <el-button type="primary" @click="onSplitConfirm" :disabled="!isValid">
        Confirm <b-spinner v-if="isLoading" class="me-2" small />
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      lineNumber: {
        default: () => null,
        type: Number
      }
    },
    data () {
      return {
        // element-ui's el-input-number displayed :min (2) for a null model; element-plus shows empty and
        // only clamps on interaction, so prefill the Vue-2 default of 2 here (min ways to split a line).
        waysToSplit: 2,
        isLoading: false
      }
    },
    methods: {
      onSplitConfirm () {
        this.isLoading = true
        this.$emit('splitLine', this.waysToSplit)
      },
      hideModal () {
        this.$parent.lineToSplit = null
      }
    },
    computed: {
      isValid () {
        return this.waysToSplit && /^\d+$/.test(this.waysToSplit)
      },
      errMsg () {
        if (this.waysToSplit && this.waysToSplit.length && !this.isValid) {
          return 'Valid integer required'
        }
        return ''
      }
    }
  }
</script>
